import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActions = ({ 
  selectedItems, 
  onClearSelection, 
  onBulkEdit, 
  onBulkDelete, 
  onExport 
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  if (selectedItems?.length === 0) {
    return null;
  }

  const handleAction = (action) => {
    switch (action) {
      case 'edit':
        onBulkEdit();
        break;
      case 'delete':
        onBulkDelete();
        break;
      case 'export':
        onExport();
        break;
      case 'clear':
        onClearSelection();
        break;
    }
    setIsDropdownOpen(false);
  };

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-1100">
      <div className="bg-card border border-border rounded-lg shadow-modal p-4 flex items-center space-x-4">
        {/* Selection Info */}
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
            <span className="text-primary-foreground text-sm font-medium">
              {selectedItems?.length}
            </span>
          </div>
          <span className="text-foreground font-medium">
            {selectedItems?.length === 1 
              ? '1 Autohaus ausgewählt' 
              : `${selectedItems?.length} Autohäuser ausgewählt`
            }
          </span>
        </div>

        {/* Actions */}
        <div className="flex items-center space-x-2">
          {/* Quick Actions */}
          {/* <Button
            variant="outline"
            size="sm"
            onClick={() => handleAction('export')}
          >
            <Icon name="Download" size={16} className="mr-2" />
            Exportieren
          </Button> */}

          {/* More Actions Dropdown */}
          <div className="relative">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              <Icon name="MoreHorizontal" size={16} className="mr-2" />
              Mehr
              <Icon name="ChevronDown" size={14} className="ml-1" />
            </Button>

            {isDropdownOpen && (
              <>
                <div
                  className="fixed inset-0 z-1000"
                  onClick={() => setIsDropdownOpen(false)}
                />
                <div className="absolute bottom-full mb-2 right-0 w-48 bg-popover border border-border rounded-lg shadow-modal py-2 z-1100">
                  <button
                    onClick={() => handleAction('edit')}
                    className="w-full flex items-center px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-colors duration-150"
                  >
                    <Icon name="Edit" size={16} className="mr-3" />
                    Bearbeiten
                  </button>
                  <div className="border-t border-border my-1" />
                  <button
                    onClick={() => handleAction('delete')}
                    className="w-full flex items-center px-4 py-2 text-sm text-error hover:bg-muted transition-colors duration-150"
                  >
                    <Icon name="Trash2" size={16} className="mr-3" />
                    Löschen
                  </button>
                </div>
              </>
            )}
          </div>

          {/* Clear Selection */}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => handleAction('clear')}
          >
            <Icon name="X" size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;